import { BrowserRouter, Routes, Route } from "react-router-dom";
import CouponSlide from "./CouponSlide";
import StatsPage from "./StatsPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CouponSlide />} />
        <Route path="/stats" element={<StatsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
